import React from 'react';
import { Box, Typography, Container, Grid, Divider } from '@mui/material';
import { motion } from 'framer-motion';
import Layout from '../components/Layout';
import './References.css';

import diversepic1 from '../assets/diversepic/1.jpg';
import diversepic2 from '../assets/diversepic/2.jpg';
import diversepic3 from '../assets/diversepic/3.jpg';
import diversepic4 from '../assets/diversepic/4.png';
import diversepic5 from '../assets/diversepic/5.jpg';
import heroBg from '../assets/efh_sirnach/2.jpg';
import hotel3 from '../assets/hotel/3.jpg';
import frenkendorf2 from '../assets/Frenkendorf/2.jpg';
import replaced1 from '../assets/replaced/1.jpg';
import replaced2 from '../assets/replaced/2.png';
import replaced3 from '../assets/replaced/3.png';

const servicesData = [
  {
    id: 1,
    title: 'Architektur & Entwurf',
    description:
      'Wir entwickeln durchdachte, funktionale und ästhetisch anspruchsvolle Architektur, die individuell auf die Bedürfnisse unserer Bauherrschaft abgestimmt ist. Vom ersten Konzept bis zur Ausführungsplanung stehen Präzision, Klarheit und zeitlose Qualität im Mittelpunkt – stets im Einklang mit Umgebung und Schweizer Bauvorschriften.',
    image: replaced3
  },
  {
    id: 2,
    title: 'Wohnbau',
    description:
      'Ob Einfamilienhaus, Mehrfamilienhaus oder Umbau – wir gestalten Lebensräume, die Komfort, Effizienz und architektonische Qualität vereinen. Dabei begleiten wir unsere Kundinnen und Kunden durch alle Projektphasen und setzen ihre Visionen in hochwertige Lösungen um.',
    image: frenkendorf2
  },
  {
    id: 3,
    title: 'Gewerbe- & Mischnutzungen',
    description:
      'Wir planen Arbeits- und Gewerberäume, die Funktionalität und gestalterische Qualität verbinden. Durch klare Strukturen und effiziente Konzepte entstehen nachhaltige und zukunftsfähige Nutzungen mit hoher Aufenthaltsqualität.',
    image: replaced1
  },
  {
    id: 4,
    title: 'Umbau & Sanierung',
    description:
      'Die Weiterentwicklung bestehender Bauten erfordert Feingefühl und Fachkompetenz. Wir erhalten den Charakter von Gebäuden und passen sie gleichzeitig an moderne Anforderungen, energetische Standards und gesetzliche Vorgaben an.',
    image: diversepic5
  },
  {
    id: 5,
    title: 'Planung & Baubewilligungen',
    description:
      'Wir übernehmen die gesamte Projektabwicklung im Bewilligungsverfahren – von Machbarkeitsstudien über die Einhaltung von Zonen- und Bauvorschriften bis hin zur erfolgreichen Einreichung. So gewährleisten wir einen reibungslosen Ablauf.',
    image: replaced2
  },
  // {
  //   id: 6,
  //   title: 'Projektleitung',
  //   description:
  //     'Wir koordinieren alle Beteiligten und steuern den gesamten Bauprozess. Dabei legen wir grossen Wert auf Qualitätssicherung, Kostenkontrolle sowie die Einhaltung von Terminen – mit transparenter Kommunikation in jeder Phase.',
  //   image: hotel3
  // },
  {
    id: 7,
    title: 'Bauleitung',
    description:
      'Während der Ausführung vertreten wir die Interessen der Bauherrschaft auf der Baustelle. Wir überwachen Qualität, Kosten und Termine, koordinieren Unternehmer und Fachplaner und stellen sicher, dass das Projekt gemäss Planung und den geltenden Normen präzise umgesetzt wird.',
    image: diversepic3
  }
];

export const References = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6
      }
    }
  };

  return (
    <Layout>
      {/* Hero Section */}
      <Box className='hero-section-references' style={{ backgroundImage: `linear-gradient(rgba(0,0,0,0.4), rgba(0,0,0,0.4)), url(${heroBg})` }}>
        <Box className='hero-overlay-references'>
          <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }}>
            <Typography
              variant='h1'
              sx={{
                fontSize: { xs: '2.5rem', sm: '3.5rem', md: '5rem' },
                fontWeight: 700,
                letterSpacing: { xs: '2px', md: '8px' },
                mb: 2,
                textShadow: '2px 2px 12px rgba(0, 0, 0, 0.7)'
              }}>
              SERVICES
            </Typography>
            <Typography
              variant='h5'
              sx={{
                fontSize: { xs: '1rem', sm: '1.25rem', md: '1.5rem' },
                fontWeight: 300,
                letterSpacing: { xs: '1px', md: '2px' },
                textShadow: '1px 1px 6px rgba(0, 0, 0, 0.7)'
              }}>
              Unsere Leistungen
            </Typography>
          </motion.div>
        </Box>
      </Box>

      {/* Introduction Section */}
      <Box sx={{ py: { xs: 8, md: 12 }, backgroundColor: '#fff' }}>
        <Container maxWidth='lg'>
          <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.8 }}>
            <Divider
              sx={{
                width: '80px',
                height: '3px',
                backgroundColor: '#1a1a1a',
                margin: '0 auto 3rem',
                border: 'none'
              }}
            />
            <Typography
              variant='h2'
              sx={{
                fontWeight: 700,
                fontSize: { xs: '1.85rem', sm: '2.25rem', md: '2.5rem' },
                mb: 4,
                textAlign: 'center',
                color: '#1a1a1a'
              }}>
              Unsere Leistungen
            </Typography>
            <Typography
              variant='body1'
              sx={{
                fontSize: { xs: '1rem', md: '1.1rem' },
                lineHeight: 1.8,
                color: '#6b6b6b',
                textAlign: 'center',
                maxWidth: '800px',
                mx: 'auto',
                mb: 6
              }}>
              Wir verstehen Architektur als präzises Zusammenspiel von Gestaltung, Funktion und Wirtschaftlichkeit. Unser Anspruch ist es, zeitlose
              Lösungen von hoher architektonischer Qualität zu schaffen – mit Klarheit im Entwurf, Sorgfalt in der Planung und Konsequenz in der
              Umsetzung.
            </Typography>
          </motion.div>
        </Container>
      </Box>

      {/* Services Grid Section */}
      <Box sx={{ py: { xs: 8, md: 12 }, backgroundColor: '#f9f9f9' }}>
        <Container maxWidth='xl'>
          <motion.div variants={containerVariants} initial='hidden' whileInView='visible' viewport={{ once: true, margin: '-100px' }}>
            <Grid container spacing={{ xs: 4, md: 6 }}>
              {servicesData.map((service, index) => {
                const isEven = index % 2 === 0;
                return (
                  <Grid item xs={12} key={service.id}>
                    <motion.div variants={itemVariants}>
                      <Box
                        sx={{
                          display: 'flex',
                          flexDirection: { xs: 'column', md: isEven ? 'row' : 'row-reverse' },
                          gap: { xs: 3, md: 6 },
                          alignItems: 'center'
                        }}>
                        {/* Image Column */}
                        <Box
                          sx={{
                            flex: { md: '0 0 50%' },
                            width: '100%',
                            position: 'relative',
                            overflow: 'hidden'
                          }}>
                          <Box
                            component='img'
                            src={service.image}
                            alt={service.title}
                            sx={{
                              width: '100%',
                              height: 'auto',
                              maxHeight: { xs: '400px', sm: '450px', md: '500px' },
                              objectFit: 'contain',
                              objectPosition: 'center',
                              transition: 'transform 0.4s ease',
                              '&:hover': {
                                transform: 'scale(1.05)'
                              }
                            }}
                          />
                        </Box>

                        {/* Content Column */}
                        <Box
                          sx={{
                            flex: { md: '0 0 50%' },
                            px: { xs: 0, md: 3 }
                          }}>
                          <Typography
                            variant='h4'
                            sx={{
                              fontWeight: 700,
                              fontSize: { xs: '1.5rem', md: '1.75rem' },
                              mb: 2,
                              color: '#1a1a1a'
                            }}>
                            {service.title}
                          </Typography>
                          <Typography
                            variant='body1'
                            sx={{
                              color: '#6b6b6b',
                              lineHeight: 1.8,
                              fontSize: { xs: '0.95rem', md: '1rem' }
                            }}>
                            {service.description}
                          </Typography>
                        </Box>
                      </Box>
                    </motion.div>

                    {/* Divider between services */}
                    {index < servicesData.length - 1 && (
                      <Divider
                        sx={{
                          mt: { xs: 4, md: 6 },
                          borderColor: '#e0e0e0'
                        }}
                      />
                    )}
                  </Grid>
                );
              })}
            </Grid>
          </motion.div>
        </Container>
      </Box>

      {/* CTA Section */}
      <Box sx={{ py: { xs: 8, md: 12 }, backgroundColor: '#1a1a1a' }}>
        <Container maxWidth='md'>
          <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.8 }}>
            <Typography
              variant='h4'
              align='center'
              sx={{
                mb: 3,
                fontWeight: 600,
                fontSize: { xs: '1.5rem', md: '2rem' },
                color: '#fff'
              }}>
              Bereit für Ihr Projekt?
            </Typography>
            <Typography
              variant='body1'
              align='center'
              sx={{
                fontSize: { xs: '1rem', md: '1.1rem' },
                lineHeight: 1.8,
                color: '#e0e0e0',
                mb: 4
              }}>
              Kontaktieren Sie uns für ein unverbindliches Beratungsgespräch. Gemeinsam entwickeln wir Ihre architektonische Vision.
            </Typography>
          </motion.div>
        </Container>
      </Box>
    </Layout>
  );
};
